import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { fetchPolicy } from "../../utils/api";

const Policy = ({ policyType }) => {
  const [content, setContent] = useState(undefined);
  const [effectiveDate, setEffectiveDate] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [version, setVersion] = useState(undefined);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetchPolicy(policyType);
        const { effective_date, html_content, version } = response.data;

        setEffectiveDate(effective_date);
        setContent(DOMPurify.sanitize(html_content));
        setVersion(version);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [policyType]);

  return (
    <div id="single">
      <Header />

      <article className="single privacy">
        <div className="wrap">
          {isLoading && <p className="text-center">Latest policy content is loading...</p>}

          <ul style={{ marginBottom: "20px" }}>
            {version && <li>[Version {version}]</li>}
            {effectiveDate && <li>[EFFECTIVE DATE: {effectiveDate}]</li>}
          </ul>

          {content && <main dangerouslySetInnerHTML={{ __html: content }} />}

          {error && (
            <p className="text-center">
              Something went wrong. Please <Link to="/contact/">contact us</Link> for questions
              about this policy.
            </p>
          )}
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default Policy;
